import { useContext, useEffect, useState } from 'react';
import supportedBrowsers from '../../supportedBrowsers';
import { SnackbarContext } from '../Providers/SnackbarProvider';

export default function useBrowserCheck() {
    const { warning } = useContext(SnackbarContext);
    const [viewed, setViewed] = useState(false);

    useEffect(() => {
        if (supportedBrowsers.test(navigator.userAgent) || viewed) {
            return;
        }

        warning('Your browser is not supported or out of date. ' +
            'Please use the latest version of Chrome, Firefox, or Edge for the best experience.')
        setViewed(true);
    }, [viewed, warning]);
}